import React from "react";
import { Container } from "@material-ui/core";
import { redirectOutside } from "../../utilities";
import { Wrapper, StyledLink, StyledArrowBackIcon } from './GoToDoveMed.styles';

export function GoToDoveMed() {
    return (
        <Wrapper>
            <Container>
                <StyledLink onClick={() => redirectOutside('/')}>
                    <StyledArrowBackIcon />
                    go to dovemed
                </StyledLink>
            </Container>
        </Wrapper>
    );
}
